module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-title'), _vm._v(" "), _c('home-navigator')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c3ab880!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/header/HomeHeader.vue
// module id = 157
// module chunks = 1